<template>
  <v-dialog max-width="550px" v-model="dialog" @keydown.enter.prevent="save">
    <v-card>
      <v-card-title>
        <span class="headline">Deprecate Config</span>
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="4" md="4">
            <r-item-deprecate-mode :model.sync="mode"/>
          </v-col>
          <v-col cols="12" sm="4" md="4" class="pt-5">
            <v-checkbox v-model="model.silent" class="mx-1 mt-0" label="Silent Mode" hide-details/>
          </v-col>
        </v-row>
        <v-row dense class="pt-4">

          <v-expansion-panels v-model="panels">
            <r-panel title="Config" v-if="mode.id === 2">
              <v-row dense>
                <v-col cols="12" md="4" sm="4">
                  <v-text-field label="Overflow:" v-model.number="model.overflow" hide-details/>
                </v-col>
              </v-row>
            </r-panel>
            <r-panel title="Config" v-else-if="mode.id === 4">
              <v-row dense>
                <v-col cols="12" md="4" sm="4">
                  <r-range :model.sync="model.lifetime" label="LifeTime"/>
                </v-col>
              </v-row>
            </r-panel>
            <r-guard-panel :hidden="mode.id !== 2" :model.sync="model.guard"/>
            <r-reward-panel :disabled="mode.id === 0" :model.sync="model.reward" title="Rewards"/>
          </v-expansion-panels>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn @click="cancel" color="blue darken-1" text>Cancel</v-btn>
        <v-btn @click="save" color="blue darken-1" text>Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {ViewRules} from "@/common/ViewRules";
import {ItemDeprecateMode} from "@/modules/redactor/models/item/deprecate/ItemDeprecateMode";
import {ItemDeprecateConfig} from "@/modules/redactor/models/item/deprecate/ItemDeprecateConfig";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RGuardPanel from "@/modules/redactor/views/guard/r-guard-panel.vue";
import RRewardPanel from "@/modules/redactor/views/reward/r-reward-panel.vue";
import RItemDeprecateMode from "@/modules/redactor/views/item/deprecate/r-item-deprecate-mode.vue";
import RRange from "@/modules/redactor/views/utils/r-range.vue";

export default {
  name: "r-item-deprecate-config",
  components: {RRange, RItemDeprecateMode, RPanel, RRewardPanel, RGuardPanel},
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    model: new ItemDeprecateConfig(),
    rules: ViewRules.READONLY,
    panels: []
  }),
  computed: {
    mode: {
      get: function () {
        return this.model ? this.model.mode : ItemDeprecateMode.DISABLED;
      },
      set: function (value) {
        this.model.mode = value;
      }
    }
  },
  methods: {
    show(rules, model) {
      this.dialog = true;
      this.rules = rules;
      this.model = model || new ItemDeprecateConfig();
      this.panels = [];
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    save() {
      if (this.model.empty()) {
        this.resolve(null);
        this.discard();
      } else if (this.model.valid()) {
        this.resolve(this.model);
        this.discard();
      } else {
        this.$alert("Invalid config!");
      }
    },
    cancel() {
      this.reject();
      this.discard();
    },
    discard() {
      this.dialog = false;
    }
  },
  watch: {
    mode() {
      this.panels = [];
    }
  }
}
</script>